import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import verify from './views/verify';
//网上预订
import market from "./views/markets/market.vue";
import order from "./views/markets/order.vue";
import ticketDetail from "./views/markets/ticketDetail";
import orderPayChoose from "./views/markets/orderPayChoose";
import uploadTheYear from './views/markets/uploadTheYear';
import buyCar from './views/markets/buyCar';
import payInfo from './views/markets/payInfo';
import drawABill from './views/markets/drawABill';
import paying from './views/markets/paying';

//游客服务
import problems from './views/services/problems';
import parkRoute from './views/services/parkRoute';
import visitorsNotice from './views/services/visitorsNotice';
import complaints from './views/services/complaints';
import workTime from './views/services/workTime';
import traffic from './views/services/traffic';
import rent from './views/services/rent';
import sale from './views/services/sale';
import parkMap from './views/services/parkMap';
import pictures from './views/services/pictures';
import Clvideo from './views/services/Clvideo';
import tourServer from './views/services/tourServer';
import serviceCheck from './views/services/serviceCheck';
//个人中心
import myOrder from "./views/personalCenter/myOrder";
import personalCenter from "./views/personalCenter/personalCenter";
import login from "./views/personalCenter/login";
import register from "./views/personalCenter/register";
import findPassword from "./views/personalCenter/findPassword";
import myJoin from "./views/personalCenter/myJoin";
import changePassword from "./views/personalCenter/changePassword";
import discount from "./views/personalCenter/discount";
import personalData from "./views/personalCenter/personalData";
import exchangeDiscount from "./views/personalCenter/exchangeDiscount";
//尾页
import aboutLong from './views/endPage/aboutLong';
import contactUs from './views/endPage/contactUs';
import joinUs from './views/endPage/joinUs';
import newsCenter from './views/endPage/newsCenter';
import resume from './views/endPage/resume';
import basicInformation from './views/endPage/basicInformation';
import joinUsDetail from './views/endPage/joinUsDetail';
import newsDetail from './views/endPage/newsDetail';
import link from './views/endPage/link';
import companyProfile from './views/endPage/companyProfile';
import share from './views/endPage/share';
import shareDetail from './views/endPage/shareDetail';

//主要乐园
import themePark from './views/parks/themePark';
import themeFarmhouse from './views/parks/themeFarmhouse';
import themeHoliday from './views/parks/themeHoliday';
import themeMilitary from './views/parks/themeMilitary';
import themeScream from './views/parks/themeScream';
import themeSea from './views/parks/themeSea';
import themeWetland from './views/parks/themeWetland';
//餐饮美食
import repast  from './views/foods/repast';
import ChineseRepast  from './views/foods/ChineseRepast';
//精彩演绎
import performance from './views/shows/performance';
import performanceDetail from './views/shows/performanceDetail';
//主题活动
import search from './views/activitys/search';
import activity from './views/activitys/activity';
import activityDetail from './views/activitys/activityDetail';
import grabbingDetail from './views/activitys/grabbingDetail';
Vue.use(Router);

export default new Router({
    mode: "hash",
    base: process.env.BASE_URL,
    routes: [
        {
            path: "/",
            name: "home",
            component: Home
        },{
            path: "/verify",
            name: "verify",
            component: verify
        },
        {
            path: "/market",
            name: "market",
            component: market   //Home
        },
        {
            path: "/order",
            name: "order",
            component: order
        },
        {
            path: "/ticketDetail",
            name: "ticketDetail",
            component: ticketDetail
        },
        {
            path: "/myOrder",
            name: "myOrder",
            component: myOrder
        },
        {
            path: '/personalCenter',
            name: 'personalCenter',
            component: personalCenter
        },
        {
            path: '/orderPayChoose',
            name: 'orderPayChoose',
            component: orderPayChoose
        },
        {
            path: '/uploadTheYear',
            name: 'uploadTheYear',
            component: uploadTheYear
        },
        {
            path: '/buyCar',
            name: 'buyCar',
            component: buyCar
        },
        {
            path: '/problems',
            name: 'problems',
            component: problems
        },
        {
            path: '/parkRoute',
            name: 'parkRoute',
            component: parkRoute
        },
        {
            path: '/login',
            name: 'login',
            component: login
        },
        {
            path: '/register',
            name: 'register',
            component: register
        },
        {
            path: '/findPassword',
            name: 'findPassword',
            component: findPassword
        },
        {
            path: '/myJoin',
            name: 'myJoin',
            component: myJoin
        },
        {
            path: '/changePassword',
            name: 'changePassword',
            component: changePassword
        },
        {
            path: '/discount',
            name: 'discount',
            component: discount
        },
        {
            path: '/personalData',
            name: 'personalData',
            component: personalData
        },
        {
            path: '/exchangeDiscount',
            name: 'exchangeDiscount',
            component: exchangeDiscount
        },
        {
            path: '/visitorsNotice',
            name: 'visitorsNotice',
            component: visitorsNotice
        },
        {
            path: '/complaints',
            name: 'complaints',
            component: complaints
        },
        {
            path: '/workTime',
            name: 'workTime',
            component: workTime
        },
        {
            path: '/traffic',
            name: 'traffic',
            component: traffic
        },
        {
            path: '/rent',
            name: 'rent',
            component: rent
        },
        {
            path: '/sale',
            name: 'sale',
            component: sale
        },
        {
            path: '/parkMap',
            name: 'parkMap',
            component: parkMap
        },
        {
            path: '/pictures',
            name: 'pictures',
            component: pictures
        },
        {
            path: '/aboutLong',
            name: 'aboutLong',
            component: aboutLong
        },
        {
            path: '/contactUs',
            name: 'contactUs',
            component: contactUs
        },
        {
            path: '/joinUs',
            name: 'joinUs',
            component: joinUs
        },
        {
            path: '/newsCenter',
            name: 'newsCenter',
            component: newsCenter
        },
        {
            path: '/resume',
            name: 'resume',
            component: resume
        },
        {
            path: '/basicInformation',
            name: 'basicInformation',
            component: basicInformation
        },
        {
            path: '/joinUsDetail/:id',
            name: 'joinUsDetail',
            component: joinUsDetail
        },
        {
            path: '/themePark',
            name: 'themePark',
            component: themePark
        },
        {
            path: '/repast',
            name: 'repast',
            component: repast
        },
        {
            path: '/ChineseRepast',
            name: 'ChineseRepast',
            component: ChineseRepast
        },
        {
            path: '/performance',
            name: 'performance',
            component: performance
        },
        {
            path: '/performanceDetail/:id',
            name: 'performanceDetail',
            component: performanceDetail
        },
        {
            path: '/search',
            name: 'search',
            component: search
        },
        {
            path: '/activity',
            name: 'activity',
            component: activity
        },
        {
            path: '/activityDetail/:id',
            name: 'activityDetail',
            component: activityDetail
        },
        {
            // path: '/grabbingDetail/:id',
            path: '/grabbingDetail',
            name: 'grabbingDetail',
            component: grabbingDetail
        },
        {
            path: '/newsDetail/:id',
            name: 'newsDetail',
            component: newsDetail
        },
        {
            path: '/Clvideo',
            name: 'Clvideo',
            component: Clvideo
        },
        {
            path: '/link',
            name: 'link',
            component: link
        },
        {
            path: '/companyProfile',
            name: 'companyProfile',
            component: companyProfile
        },
        {
            path: '/payInfo',
            name: 'payInfo',
            component: payInfo
        },
        {
            path: '/drawABill',
            name: 'drawABill',
            component: drawABill
        },
        {
            path: '/paying',
            name: 'paying',
            component: paying
        },{
            path: '/themeFarmhouse',
            name: 'themeFarmhouse',
            component: themeFarmhouse
        },{
            path: '/themeHoliday',
            name: 'themeHoliday',
            component: themeHoliday
        },
        {
            path: '/themeMilitary',
            name: 'themeMilitary',
            component: themeMilitary
        },{
            path: '/themeScream',
            name: 'themeScream',
            component: themeScream
        },
        {
            path: '/themeSea',
            name: 'themeSea',
            component: themeSea
        },{
            path: '/themeWetland',
            name: 'themeWetland',
            component: themeWetland
        },{
            path: '/share',
            name: 'share',
            component: share
        },{
            path: '/shareDetail/:id',
            name: 'shareDetail',
            component: shareDetail
        },{
            path: '/tourServer',
            name: 'tourServer',
            component: tourServer
        },
{
            path: '/serviceCheck',
            name: 'serviceCheck',
            component: serviceCheck
        },


    ],
   /* scrollBehavior(to,from,savePosition){ // 在点击浏览器的“前进/后退”，或者切换导航的时候触发。
        console.log(to) ;// to：要进入的目标路由对象，到哪里去
        console.log(from) ;// from：离开的路由对象，哪里来
        console.log(savePosition) ;// savePosition：会记录滚动条的坐标，点击前进/后退的时候记录值{x:?,y:?}
        if(to.hash){ //先判断目标路由有没有hash值
            return {selector:to.hash}
        }
    }*/
});
